import "./App.css";

import MoviePage from "./Layout/MoviePage";

function App() {
  return (
    <>
      <MoviePage />
    </>
  );
}

export default App;
